import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0400Component } from './kymw0400.component';
import { GetSupplierListService } from './api-services/get-supplier-list.service';

import {AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * 取引先一覧画面 モジュール設定クラス
 *
 * @export KYMW0400Module
 * @class KYMW0400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
  ],
  declarations: [
    KYMW0400Component,
  ],
  providers: [
    GetSupplierListService,
  ],
})
export class KYMW0400Module {
}
